import { HStack, Circle, MenuPositioner, Box, Spinner, Text, Icon } from "@chakra-ui/react"
import { MenuContent, MenuItem, MenuRoot, MenuTrigger } from "@chakra-ui/react"
import { useAuth } from "../../auth/AuthProvider"
import { useNavigate } from "react-router-dom"
import { FaChevronDown, FaUser } from "react-icons/fa6"
import { useFeatureEnabled } from "../../hooks/useFeatureToggles"
import { useState } from "react"

export const UserProfile = ({ expanded = false }: { expanded?: boolean }) => {
  const { user, signOut, signingOut } = useAuth()
  const navigate = useNavigate()
  const isWhatsNewEnabled = useFeatureEnabled("whats_new")
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  if (!user) return null

  const initials =
    user.name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) || user.email[0].toUpperCase()

  return (
    <Box color="primary" width={"100%"}>
      <MenuRoot onOpenChange={(open) => setIsMenuOpen(open.open)} open={isMenuOpen}>
        <MenuTrigger width={"100%"}>
          <HStack width={"100%"} gap={"3px"}>
            <Circle
              size="32px"
              bg={isMenuOpen ? "active" : "sidebar"}
              _hover={{ bg: "active", cursor: "pointer" }}
              color="white"
              fontSize="sm"
              fontWeight="semibold"
            >
              <Icon as={FaUser} color="white" />
            </Circle>
            {expanded && (
              <Text color="white" _hover={{ cursor: "pointer" }}>
                {user.name}
              </Text>
            )}
          </HStack>
        </MenuTrigger>
        <MenuPositioner>
          <MenuContent backgroundColor="blue" display="flex" flexDirection="column" gap={"3px"} padding="3px">
            {user.role === "admin" && (
              <MenuItem
                value="admin-settings"
                onClick={() => navigate("/settings/admin")}
                bg={"blue"}
                color="white"
                _hover={{ bg: "active", cursor: "pointer" }}
              >
                Admin Settings
              </MenuItem>
            )}
            {isWhatsNewEnabled && (
              <MenuItem
                value="whats-new"
                onClick={() => navigate("/whats-new")}
                bg={"blue"}
                color="white"
                _hover={{ bg: "active", cursor: "pointer" }}
              >
                What's New
              </MenuItem>
            )}
            <MenuItem
              value="change-password"
              onClick={() => navigate("/settings/password")}
              bg={"blue"}
              color="white"
              _hover={{ bg: "active", cursor: "pointer" }}
            >
              Change Password
            </MenuItem>
            <MenuItem
              value="sign-out"
              onClick={signOut}
              disabled={signingOut}
              bg={"blue"}
              color="white"
              _hover={{ bg: "active", cursor: "pointer" }}
              opacity={signingOut ? 0.6 : 1}
            >
              <HStack gap={2}>
                {signingOut && <Spinner size="sm" />}
                <span>Sign Out{signingOut ? "..." : ""}</span>
              </HStack>
            </MenuItem>
          </MenuContent>
        </MenuPositioner>
      </MenuRoot>
    </Box>
  )
}
